import React from 'react';
import { Home, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './404.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-container">
      {/* Background Effects */}
      <div className="background-overlay"></div>
      <div className="background-orb orb-1"></div>
      <div className="background-orb orb-2"></div>
      <div className="floating-particles"></div>

      <div className="not-found-content">
        <div className="error-code">404</div>
        <h1 className="error-title">Page Non Trouvée</h1>
        <p className="error-description">
          Oups ! La page que vous recherchez semble avoir disparu dans le cyberespace.
        </p>

        <div className="error-actions">
          <button 
            onClick={() => navigate('/')} 
            className="action-button home-button"
          >
            <Home size={20} />
            Retour à l'accueil
          </button>
          <button 
            onClick={() => window.location.reload()} 
            className="action-button reload-button"
          >
            <RefreshCw size={20} />
            Rafraîchir la page
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;